import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useAssetState = () => React.useContext(Context)
export const useAsset = () => useAssetState()?.asset

const QUERY = gql`
  query Asset($id: ID) {
    asset(id: $id, filter: { includeDisabled: true }) {
      id
      name
      enabled
      qrcodes {
        id
        updatedAt
      }
      place {
        id
        name
        resume
      }
      fieldValues {
        id
        value
        field {
          id
          name
          type
          ordination
          configuration
        }
      }
      type {
        id
        name
        entity
        deleted
      }
      deleted
      insertedAt
      updatedAt
    }
  }
`

const AssetLoader = ({ children }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: placesClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default AssetLoader
